<template>
  <div class="page">
    <i class="left iconfont icon-youjiantou"></i>
    <div class="item" :class="{active: curi===k}" v-for='(i,k) in new Array(Math.ceil(total / size))' :key='k'>{{k+1}}
    </div>
    <i class="right iconfont icon-youjiantou"></i>
  </div>
</template>

<script>
  export default {
    props: {
      total: Number,
      size: Number,
    },
    data: () => ({
      curi: 0
    }),
    methods: {
    }
  }
</script>

<style lang="stylus" scoped>
  @import "~styl/mixin.styl"

  theme = #f7aa05

  .page
    ta(center)
    fs(0)

    .item
      ib()
      w(40)
      h(30)
      ml(10)
      mr(10)
      va(middle)
      fs(17)
      lh(30)
      c(gray)
      _hover()

      &.active
        bg(theme)
        c(#fff)

    .left
      fs(15)
      c(gray)
      ib()
      transform rotate(180deg)
      vertical-align -4px
      mr(10)

      &:hover
        cursor pointer

    .right
      &:hover
        cursor pointer
      ml(10)
      va(middle)
      c(gray)
      fs(15)


</style>



// WEBPACK FOOTER //
// src/components/page.vue